<template>
  <div>
    <el-table :data="logList">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <!-- {{scope.row.createTime | moment}} -->
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope"> </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LogList',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('logs', ['logList'])
  }
};
</script>

<style lang="less" scoped></style>
